module.exports = __webpack_public_path__ + "static/media/3area.1a51e835.jpg";